import { inject } from '@angular/core';
import { CanActivateFn, Router } from '@angular/router';
import { TokenService } from '../auth/token.service';
import { AuthService } from '../auth/auth.service';
import { catchError, map, of } from 'rxjs';
import { CurrentUserService } from '../auth/current-user.service';
import { PortalContextService } from '../auth/portal-context.service';

export const authGuard: CanActivateFn = (_route, state) => {
  const token = inject(TokenService).getAccessToken();
  const router = inject(Router);
  const auth = inject(AuthService);
  const currentUser = inject(CurrentUserService);
  const portal = inject(PortalContextService);
  const loginRoute = portal.isDedicatedHost
    ? portal.loginRoute
    : state.url.startsWith('/franchise') ? '/franchise-login' : state.url.startsWith('/business') ? '/login' : '/admin-login';

  if (token) {
    return auth.ensureFreshSession().pipe(
      map((user) => {
        if (!user) return router.createUrlTree([loginRoute]);
        if (portal.isDedicatedHost && portal.userPortal(user) !== portal.portal) {
          auth.logout();
          return router.createUrlTree([portal.loginRoute], { queryParams: { portalMismatch: '1' } });
        }
        if (user.mustChangePassword && state.url !== '/change-password') {
          return router.createUrlTree(['/change-password']);
        }
        if (!user.mustChangePassword && state.url === '/change-password') {
          return router.createUrlTree([user.tenantId ? currentUser.businessLandingRoute() : '/admin/dashboard']);
        }
        return true;
      }),
      catchError(() => {
        auth.logout();
        return of(router.createUrlTree([loginRoute]));
      }),
    );
  }

  return router.createUrlTree([loginRoute]);
};
